import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
// Nota: Certifique-se de que os caminhos abaixo estejam corretos no seu projeto
import PrivateMenuLeft from "../../sections/Header/privateMenuLeft";
import PrivateMenuUp from "../../sections/Header/privateMenuUp";
import useAuth from "../../../../components/hooks/useAuth";
import LogoIcone from "../../../../assets/notifyicone.png";
import Loader from "../../../../components/Loader";
import EditLinkedZapModalComponent from "./modalEdit";

// Ícones simples via SVG
const IconEdit = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>;
const IconPower = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path><line x1="12" y1="2" x2="12" y2="12"></line></svg>;
const IconExternal = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>;
const IconTrash = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>;

const HEADER_HEIGHT = 70;

const Editarconta = () => {
  // --- Estados Originais Mantidos ---
   const [showEditModal, setShowEditModal] = useState(false);
   const [loading, setLoading] = useState(false);
  const [linkedZap, setlinkedZap] = useState([]);

  // --- Novos Estados para Listas de Conexões ---
  const [campanhas, setCampanhas] = useState([]);
  const [broadcasts, setBroadcasts] = useState([]);

  // --- Hooks ---
  const { sidebarOpen, getApi, postApi, deleteApi } = useAuth();
  const { id: linkedZapId } = useParams();
  const isMobile = window.innerWidth <= 768;

  // --- Funções Originais Mantidas ---
  useEffect(() => {
    loadLinkedZap();
  }, []);

  const disconnect = async () => {
    if (!window.confirm("Tem certeza que deseja desconectar esta conta?")) return;
    setLoading(true);
    try {
      let response = await postApi("/api/v1/linkedZap/disconnect/" + linkedZapId);
      if (response.status == 'fail') {
        window.alert(response.message);

      } else {
        alert("Conta desconectada com sucesso!");
      }

      loadLinkedZap();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const deleteInstance = async () => {
    if (!window.confirm("Tem certeza que deseja excluir esta conta?")) return;
    setLoading(true);
    try {
      let response = await deleteApi("/api/v1/linkedZap/delete/" + linkedZapId);
      if (response.status == 'fail') {
        window.alert(response.message);

      } else {
        alert("Conta excluida com sucesso!");
          navigate('/Contas/' )

      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };



  const loadLinkedZap = async () => {
    setLoading(true);
    try {
      let response = await getApi("/api/v1/linkedZap/show/" + linkedZapId, []);
      setlinkedZap(response);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };



  // --- Estilos Auxiliares ---
  const cardStyle = {
    background: "#fff",
    borderRadius: "12px",
    padding: "24px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    border: "1px solid #eee",
  };

  const sectionTitleStyle = {
    fontSize: "14px",
    fontWeight: "600",
    color: "#888",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    marginBottom: "16px",
    display: "flex",
    alignItems: "center",
    gap: "8px"
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh", backgroundColor: "#f8f9fa" }}>
      <PrivateMenuLeft />
      <PrivateMenuUp />

      <Helmet>
        <title>{`Editar Conta: ${linkedZap.name}`}</title>
      </Helmet>

      <div
        style={{
          marginLeft: isMobile ? 56 : sidebarOpen ? 220 : 70,
          marginTop: HEADER_HEIGHT,
          width: isMobile
            ? "calc(100vw - 56px)"
            : sidebarOpen
              ? "calc(100% - 220px)"
              : "calc(100% - 70px)",
          transition: "margin-left 0.3s, width 0.3s",
          padding: "24px"
        }}
      >

        <div style={{ maxWidth: "1100px", margin: "0 auto", display: loading ? 'none' : 'block' }}>

          {/* HEADER DA CONTA */}
          <div style={{ ...cardStyle, display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center", gap: "20px", marginBottom: "24px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <div style={{ position: "relative", width: "80px", height: "80px" }}>
                <div style={{
                  width: "100%", height: "100%", borderRadius: "50%", overflow: "hidden",
                  border: "3px solid #51a197", background: "#f0f0f0"
                }}>
                  <img
                    src={linkedZap.profilePictureUrl || LogoIcone}
                    alt="Foto"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                </div>
                <div style={{
                  position: "absolute", bottom: "4px", right: "4px", width: "16px", height: "16px",
                  borderRadius: "50%", background: linkedZap.connected ? "#28c76f" : "#ccc", border: "2px solid #fff"
                }} className={linkedZap.connected ? "pulse-editarconta" : ""}></div>
              </div>

              <div>
                <h2 style={{ margin: 0, fontSize: "22px", color: "#333" }}>{linkedZap.name}</h2>
                <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "4px" }}>
                  <span style={{ color: linkedZap.connected ? "#25D366" : "#999", fontWeight: "600" }}>
                    {linkedZap.connected ? "Conectado" : "Desconectado"}
                  </span>
                  <span style={{ color: "#999" }}>•</span>
                  <span style={{ color: "#666" }}>{linkedZap.whatsapp_id}</span>
                </div>
              </div>
            </div>

            {/* Ações Principais Visíveis */}
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              <button
                onClick={e=> setShowEditModal(true)}
                style={{
                  display: "flex", alignItems: "center", gap: "8px", padding: "10px 18px",
                  background: "#fff", border: "1px solid #ddd", borderRadius: "8px",
                  cursor: "pointer", fontWeight: "600", color: "#555", transition: "all 0.2s"
                }}
              >
                <IconEdit /> Editar Dados
              </button>

              <button
                onClick={disconnect}
                style={{
                  display: "flex", alignItems: "center", gap: "8px", padding: "10px 18px",
                  background: "#fff", border: "1px solid #ff4d4f", borderRadius: "8px",
                  cursor: "pointer", fontWeight: "600", color: "#ff4d4f", transition: "all 0.2s"
                }}
              >
                <IconPower /> Desconectar
              </button>

              <button
                onClick={() => window.open("/public/whatsapp/" + linkedZapId, '_blank')}
                style={{
                  display: "flex", alignItems: "center", gap: "8px", padding: "10px 20px",
                  background: linkedZap.connected ? "#ccdfdc" : "#51a197", color: "#fff", border: "none", borderRadius: "8px",
                  cursor: "pointer", fontWeight: "bold", opacity: linkedZap.connected ? 0.7 : 1
                }}
                disabled={linkedZap.connected}
              >
                Conectar Conta <IconExternal />
              </button>
            </div>
          </div>


          {/* GRID DE CONEXÕES */}
          <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr 1fr", gap: "20px", marginBottom: "40px" }}>

            {/* Coluna Campanhas */}
            <div style={cardStyle}>
              <div style={sectionTitleStyle}>
                <span>📁 Campanhas Ativas</span>
                <span style={{ marginLeft: "auto", background: "#eee", padding: "2px 8px", borderRadius: "10px", fontSize: "12px" }}>
                  {campanhas.length}
                </span>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                {campanhas.length > 0 ? campanhas.map(item => (
                  <div key={item.id} style={{ padding: "12px", background: "#f9f9f9", borderRadius: "8px", fontSize: "14px", color: "#444", borderLeft: "4px solid #51a197" }}>
                    {item.name}
                  </div>
                )) : (
                  <div style={{ textAlign: "center", color: "#ccc", padding: "20px" }}>Nenhuma campanha vinculada.</div>
                )}
              </div>
            </div>


            {/* Coluna Broadcast */}
            <div style={cardStyle}>
              <div style={sectionTitleStyle}>
                <span>📢 Listas de Transmissão</span>
                <span style={{ marginLeft: "auto", background: "#eee", padding: "2px 8px", borderRadius: "10px", fontSize: "12px" }}>
                  {broadcasts.length}
                </span>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                {broadcasts.length > 0 ? broadcasts.map(item => (
                  <div key={item.id} style={{ padding: "12px", background: "#f9f9f9", borderRadius: "8px", fontSize: "14px", color: "#444", borderLeft: "4px solid #3498db" }}>
                    {item.name}
                  </div>
                )) : (
                  <div style={{ textAlign: "center", color: "#ccc", padding: "20px" }}>Nenhum broadcast configurado.</div>
                )}
              </div>
            </div>

          </div>

          {/* ZONA DE PERIGO (MELHORADA) */}
          <div style={{
            marginTop: "40px",
            padding: "24px",
            backgroundColor: "#fff",
            borderRadius: "12px",
            border: "1px solid #ffe5e5",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "20px"
          }}>
            <div>
              <h4 style={{ margin: "0 0 4px 0", color: "#d32f2f", fontSize: "16px", fontWeight: "700" }}>Zona de Perigo</h4>
              <p style={{ margin: 0, color: "#777", fontSize: "14px" }}>
                Ao excluir esta instância, todas as configurações e conexões ligadas a ela serão removidas permanentemente.
              </p>
            </div>

            <button
              onClick={() => deleteInstance()}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "12px 24px",
                backgroundColor: "#fff",
                color: "#d32f2f",
                border: "1px solid #d32f2f",
                borderRadius: "8px",
                cursor: "pointer",
                fontWeight: "bold",
                transition: "all 0.3s ease",
                fontSize: "14px"
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = "#d32f2f";
                e.currentTarget.style.color = "#fff";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = "#fff";
                e.currentTarget.style.color = "#d32f2f";
              }}
            >
              <IconTrash /> Excluir Instância
            </button>
          </div>

        </div>
        {loading && <Loader />}
      </div>
      <EditLinkedZapModalComponent
        showModalAddLinkedZap={showEditModal}
        setShowModalAddLinkedZap={e=> {setShowEditModal(e), loadLinkedZap();} }
        key={showEditModal}
        linkedZap={linkedZap}
      />

      <style>{`
        @keyframes pulse-membros {
          0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(40, 199, 111, 0.7); }
          70% { transform: scale(1); box-shadow: 0 0 0 10px rgba(40, 199, 111, 0); }
          100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(40, 199, 111, 0); }
        }
        .pulse-editarconta {
          animation: pulse-membros 2s infinite;
        }
      `}</style>
    </div>
  );
};

export default Editarconta;